import { Agenda } from './Agenda';
import { ChannelsStats } from './ChannelsStats';
import { ContactStats } from './ContactStats';

export interface ContactMessageChannelStats {
    contactStats: ContactStats;
    channelsStats: ChannelsStats[];
    agenda: Agenda;
}

export interface ContactMessageChannelRequest {
    contactsDate: string;
    channelsDate: string;
}

/**
 * buildCreateContactMessageChannelRequest
 *
 * @description
 * Builds an object matching that expected by the server for a create new
 * contact request
 */
export function buildContactMessageChannelRequest(args: {
    contactsDate: string;
    channelsDate: string;
}): ContactMessageChannelRequest {
    return {
        contactsDate: args.contactsDate || '',
        channelsDate: args.channelsDate || '',
    };
}
